import { quickStats } from "@/mocks/content";

export default function StatsBar() {
  return (
    <section className="bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-8 md:px-6 md:py-10">
        <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
          {quickStats.map((item, index) => (
            <div
              key={item.label}
              className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-4"
            >
              <span
                className={`flex h-11 w-11 items-center justify-center rounded-md ${
                  index % 3 === 0
                    ? "bg-primary-100 text-primary-700"
                    : index % 3 === 1
                      ? "bg-accent-100 text-accent-700"
                      : "bg-secondary-100 text-secondary-900"
                }`}
              >
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <div>
                <p className="font-heading text-xl font-bold text-foreground-950">{item.value}</p>
                <p className="text-xs text-foreground-600">{item.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}